import { Component, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { NanorepAnswer, QuickAnswer } from '../nanorep-sdk';

@Component({
  selector: 'nanorep-answer',
  templateUrl: './nanorep-answer.component.html',
  styleUrls: ['./nanorep-answer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NanorepAnswerComponent implements AfterViewInit {
  constructor() {
    this.onClick = () => {
      this.articleClick.emit(this._answer.summary);
    };

    this.onExpand = () => {
      this.expand.emit();
    };

    this.onCollapse = () => {
      this.collapse.emit();
    };

    this.onFocus = () => {
      this.focus.emit(this);
    };
  }

  private _answer: NanorepAnswer;
  private initialized: boolean = false;
  private nrAnswer: QuickAnswer;
  public size: number;
  public hovered: boolean;

  @ViewChild('container', { static: true }) container: ElementRef;

  @Output() articleClick: EventEmitter<string> = new EventEmitter<string>();
  @Output() expand: EventEmitter<void> = new EventEmitter<void>();
  @Output() collapse: EventEmitter<void> = new EventEmitter<void>();
  @Output() focus: EventEmitter<NanorepAnswerComponent> = new EventEmitter<NanorepAnswerComponent>();

  @Input() focused: boolean;

  @Input()
  public set config(newAnswer: {answer: NanorepAnswer, size: number}) {
    this._answer = newAnswer.answer;
    this.size = newAnswer.size;
    if (!this.nrAnswer && this.initialized) {
      this.renderAnswer();
    }
  }

  public get config(): {answer: NanorepAnswer, size: number} {
    return {answer: this._answer, size: this.size};
  }

  public scroll(): void {
    this.container.nativeElement.scrollIntoView();
  }

  public get answer(): NanorepAnswer {
    return this._answer;
  }

  ngAfterViewInit(): void {
    this.initialized = true;
    if (this._answer && !this.nrAnswer) {
      this.renderAnswer();
    }
  }

  toggle() {
    if (this.nrAnswer) {
      this.nrAnswer.toggle();
    }
  }

  private renderAnswer() {
    const widgetContentPadding = 54;
    this.nrAnswer = new window.nanorep.sdk.QuickAnswer({
      answer: this._answer,
      contentHeight: this.size - widgetContentPadding
    }, this.container.nativeElement);
    this.nrAnswer.on({
      click: this.onClick,
      expand: this.onExpand,
      collapse: this.onCollapse
    });
  }

  private onClick: () => void;
  private onExpand: () => void;
  private onCollapse: () => void;
  public onFocus: () => void;
}
